export const getRandomColor = () => {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const extractRgbFromColor = (color?: string) => {
  if (!color) return '0, 0, 0'; // Default to black

  // Match rgba or rgb pattern and extract the RGB values
  const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (rgbaMatch) {
    return `${rgbaMatch[1]}, ${rgbaMatch[2]}, ${rgbaMatch[3]}`;
  }

  // If no match, return default
  return '0, 0, 0';
};
